var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app-wrapper"}},[_c('server'),_c('div',{ref:"content",staticClass:"flex-fill overflow-hidden",attrs:{"id":"app-content"}},[_c('div',{staticClass:"top-content"}),_c('transition',{attrs:{"name":_vm.routerTransition,"mode":"out-in"}},[_vm._t("default")],2)],1),_c('Menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }